export default "__VITE_PUBLIC_ASSET__9e34c20a__"